<template>
  <Transition name="fade">
    <main
      v-if="copaLoading"
      class="absolute inset-0 grid place-items-center z-50 h-screen"
    >
      <q-spinner-tail color="primary-pure" size="3rem" />
    </main>

    <main v-else class="space-y-32 mb-160 sm:space-y-16">
      <header
        class="fixed top-0 left-0 right-0 z-40 transition-all duration-300"
        :class="[
          isScrolled
            ? 'bg-white border-b border-neutral-100/5 shadow-sm'
            : 'bg-transparent border-b border-transparent',
        ]"
      >
        <div
          class="container max-w-[96rem] mx-auto flex items-center justify-between py-16 px-16"
        >
          <TextIcon
            icon="svguse:#icon_cube"
            text="Copa Dashboard 2025"
            icon-class="text-primary-pure"
            div-class="!gap-12 !font-normal"
          />

          <div
            class="flex items-center gap-16 flex-nowrap sm:mt-16 sm:w-full"
          >
            <OButton
              size="lg"
              class="w-48 h-48 !bg-[#EFEFEF] text-neutral-70 !border-none"
              tertiary
              icon="print"
              @click="printWindow"
            >
              <q-tooltip> Imprimir </q-tooltip>
            </OButton>

            <FilterDashboard @filter-applied="updateDashboard" />
          </div>
        </div>
      </header>

      <div
        class="container max-w-[96rem] mx-auto pt-72 px-16 space-y-32 sm:space-y-16 sm:pt-120 main-container"
      >
        <div
          v-if="summaryCardsLoading"
          class="grid grid-cols-4 md2:!grid-cols-2 sm:!grid-cols-1 gap-16 sm:gap-8"
        >
          <q-skeleton
            v-for="n in 4"
            :key="n"
            type="card"
            class="rounded-xl shadow-sm h-[8.75rem]"
          />
        </div>

        <div
          v-else
          class="grid md2:!grid-cols-2 sm:!grid-cols-1 gap-16 sm:gap-8"
          :style="`grid-template-columns: repeat(${summaryCards.length}, minmax(0, 1fr));`"
        >
          <CardSummary
            v-for="(card, index) in summaryCards"
            :key="card.key"
            :index="index"
            v-bind="card"
          />
        </div>
      </div>

      <HorizontalEnablers />

      <section
        class="container max-w-[96rem] mx-auto px-16 space-y-24 sm:space-y-16"
      >
        <CardCupEvolution />

        <CardPerformanceByCategory
          ref="cardPerformanceByCategoryRef"
        />

        <!-- <div class="grid grid-cols-2 gap-24">
          <q-card
            class="rounded-xl border border-neutral-100/5 shadow-sm p-24"
          >
            <CardMyQuickWins />
          </q-card>
  
          <q-card
            class="rounded-xl border border-neutral-100/5 shadow-sm p-24"
          >
            <CardMyHighlights />
          </q-card>
        </div> -->
      </section>
    </main>
  </Transition>
</template>

<script setup>
import { copaLoading } from 'store/copa.stores'
import { onMounted, onUnmounted, ref } from 'vue'
import { summaryCards, summaryCardsLoading } from 'store/copa.stores'
import CardCupEvolution from 'components/DashboardCopa/CardCupEvolution.vue'
import CardPerformanceByCategory from 'components/DashboardCopa/CardPerformanceByCategory.vue'
import CardSummary from 'components/DashboardCopa/CardSummary.vue'
import FilterDashboard from 'components/DashboardCopa/FilterDashboard.vue'
import HorizontalEnablers from 'components/DashboardCopa/HorizontalEnablers.vue'
import TextIcon from 'components/Text/TextIcon.vue'
import useCopaReports from 'composables/useCopaReports'
import OButton from 'components/Button/OButton.vue'

const { requestAuth, refreshDashboard } = useCopaReports()

const cardPerformanceByCategoryRef = ref(null)
const isScrolled = ref(false)

function printWindow() {
  window.print()
}

function handleScroll() {
  isScrolled.value = window.scrollY > 10
}

function updateDashboard() {
  // Obtém o fab_code da coluna dinâmica, se existir
  refreshDashboard(cardPerformanceByCategoryRef)
}

async function initialRequests() {
  await requestAuth()
  updateDashboard()
}

onMounted(() => {
  initialRequests()
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style lang="scss" scoped>
header.fixed {
  @media print {
    position: static !important;
    box-shadow: none !important;
    border: none !important;
  }
}

.main-container {
  @media print {
    padding-top: 0 !important;
  }
}
</style>
